// extracted by mini-css-extract-plugin
export var additionalBackground = "hero-module--additionalBackground--26AWY";
export var body = "hero-module--body--byIO3";
export var buttonContainer = "hero-module--buttonContainer--DjfVB";
export var hero = "hero-module--hero--6D8n+";
export var heroWithIcons = "hero-module--heroWithIcons--iWqO9";
export var heroWithMedia = "hero-module--heroWithMedia--fRvnk";
export var iconContainer = "hero-module--iconContainer--iFg+E";
export var icons = "hero-module--icons--6vvwK";
export var mainImage = "hero-module--mainImage--Bvab9";
export var mainVideo = "hero-module--mainVideo--sUeQr";
export var sbShowMain = "hero-module--sb-show-main--vktQ3";
export var simple = "hero-module--simple--LS5ln";
export var storybook = "hero-module--storybook--NUPz1";
export var storybookPlayButton = "hero-module--storybookPlayButton--+I+v5";
export var withImage = "hero-module--withImage--RLsHu";